import { useTranslation } from '@/hooks/useTranslation';
import { useReveal } from '@/hooks/useReveal';

const ProcessSection = () => {
  const { t } = useTranslation();
  useReveal();

  return (
    <section id="process">
      <div className="process-header">
        <div className="section-tag">{t.process.tag}</div>
        <h2 className="section-h" style={{ whiteSpace: 'pre-line' }}>
          {t.process.title.split('\n').map((line, i) => (
            <span key={i}>{i === 0 ? <>{line}<br /></> : <em>{line}</em>}</span>
          ))}
        </h2>
        <p className="section-sub">{t.process.subtitle}</p>
      </div>

      <div className="process-steps">
        {t.process.steps.map((step, i) => (
          <div className={`p-step rev del-${i + 1}`} key={i}>
            <div className="p-num">{step.num}</div>
            <h4>{step.title}</h4>
            <p>{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProcessSection;
